import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, AlertController, ToastController } from 'ionic-angular';
import { HttpChildProvider } from '../../../providers/http-child';
import { BasicState } from '../../../states/basic-state';
import { AbstractPage } from '../../_com/abstract-page';
import _ from 'underscore';

/**
 * Generated class for the ChildEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-child-edit',
  templateUrl: 'child-edit.html',
})
export class ChildEditPage extends AbstractPage {

	child = {};
  family = {};
  isUpdate = false;

  constructor(
    public navCtrl: NavController,
    private navParams: NavParams,
    public modalController:ModalController,
    public viewController:ViewController,
    public alertController:AlertController,
    public toastController:ToastController,
    private httpChildProvider:HttpChildProvider,
    private basicState:BasicState,
    private el: ElementRef) {
    super();

    super.readyDomAccess(this.el);
  }

  ionViewDidLoad() {

    //家族データ
    if (this.navParams.data.family){
      this.family = _.clone(this.navParams.data.family);
    }

    //子供データ
    if (this.navParams.data.child){
      this.isUpdate = true;
      this.child = _.clone(this.navParams.data.child);
      this.child["newChild"] = false;
      if(this.child["birthday"]){
        this.child["birthday"] = new Date(this.child["birthday"]);
      }
      // 旧データの 99 は あじ が未確認のため、個別の食材へ展開して表示する
      this.child["tabetakotoaru_foods"] = this.expandLegacyTabetakotoaruFoods(this.child["tabetakotoaru_foods"]);
    } else {
      this.child["familyId"] = this.family["id"];
      this.child["newChild"] = true;
    }

    this.refleshTimeData(this.child);
  }

  /**
   * 保存処理
   */
  save(){
    //必須チェック
    if(this.hasInvalidRequired()){
      this.alert(this.alertController, "未入力の項目を確認してください");
      return;
    }

    this.confirm(this.alertController, "入力内容で保存します。よろしいですか？", ()=>{
    	this.httpChildProvider.save(this.child).subscribe((res)=>{
    		this.basicState.triggerChildDetailRefresh(res.data.Child);
    		this.navCtrl.pop();
    	});
    });
  }

  onChangeTabetakotoaruFoods() {
    // 99: 全て食べたことがあるが 選択されている場合は、全て食べたことにする
    // ただし あじ が選択された場合は 99 を解除して個別の食材へ展開する
    this.child["tabetakotoaru_foods"] = this.normalizeTabetakotoaruFoods(this.child["tabetakotoaru_foods"]);
  }

  onChangeRinyushokuTabetakotoaruFoods() {
    const rinyushoku_tabetakotoaru_shokuzai: any[] = this.child["rinyushoku_tabetakotoaru_shokuzai"];
    // 99: 全て食べたことがあるが 選択されている場合は、全て食べたことにする
    if (!rinyushoku_tabetakotoaru_shokuzai?.includes("all")) {
      return false;
    }
    this.child["rinyushoku_tabetakotoaru_shokuzai"] = this.child["rinyushoku_tabetakotoaru_shokuzai"].filter(key => {
      return key === "all";
    })
  }

  onChangekeijyoYasai() {
    if (this.child["keijyo_yasai"] && (this.child["keijyo_yasai"] === '1' || this.child["keijyo_yasai"] === '2')) {
      this.child["rinyushoku_tabetakotoaru_shokuzai"] = [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/child/edit/child-edit.ts